import React, { useState , useEffect } from "react";
import { useNavigate ,Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
function Header({ isAuthenticated = false }) {
  const [isOpen, setIsOpen] = useState(false);
  const [animate, setAnimate] = useState(false);

  const openMenu = () => {
    setIsOpen(true);
    setTimeout(() => setAnimate(true), 10);
  };

  const closeMenu = () => {
    setAnimate(false);
    setTimeout(() => setIsOpen(false), 300);
  };
  const navigate = useNavigate();

  const handleLogout = () => {
      localStorage.removeItem('token');
      window.location.reload();
      navigate('/', { replace: true });
    };
    useEffect(() => {
      if (!localStorage.getItem('token')) {
        
      }
    }, [navigate]);

  return (
    <header className="bg-[#0F2C5E] text-white py-4 px-6 flex items-center justify-between shadow-md">
      {/* Logo */}
      <Link to="/" className="flex items-center">
        <div className="flex items-center space-x-3">
          <img
            src="/logo.png"
            alt="Logo"
            className="h-12 w-12 rounded-xl"  // 48×48px и более сильное скругление
          />
          <span className="font-bold text-xl">2290PAY</span>
        </div>
      </Link>

      {/* Desktop Nav */}
      <nav className="hidden md:flex space-x-8 text-sm font-medium tracking-wide">
        <Link to="/pricing" className="hover:underline">Pricing</Link>
        <Link to="/due-dates" className="hover:underline">2290 Due Dates</Link>
        <Link to="/contact" className="hover:underline">Contact Us</Link>
      </nav>

      {/* Desktop Buttons */}
      <div className="hidden md:flex space-x-3">
        {isAuthenticated ? (
           <>
            <Link to="/dashboard">
              <button className="px-5 py-2 bg-[#0F2C5E] text-white border border-white hover:bg-white hover:text-[#0F2C5E] transition-colors duration-150 text-sm uppercase tracking-wide">
                File Form
              </button>
            </Link>
            <button
              onClick={handleLogout}
              className="px-5 py-2 bg-transparent text-white border border-white hover:bg-white hover:text-[#0F2C5E] transition-colors duration-150 text-sm uppercase tracking-wide"
            >
              Logout
            </button>
          </>
        ) : (
          <>
            <Link to="/sign-up">
              <button className="px-5 py-2 bg-transparent text-white border border-white hover:bg-white hover:text-[#0F2C5E] transition-colors duration-150 text-sm uppercase tracking-wide">
                Register
              </button>
            </Link>
            <Link to="/sign-in">
              <button className="px-5 py-2 bg-white text-[#0F2C5E] border border-white hover:bg-gray-100 transition-colors duration-150 text-sm uppercase tracking-wide">
                Login
              </button>
            </Link>
          </>
        )}
      </div>

      <button onClick={openMenu} className="md:hidden text-white">
        <Menu size={24} />
      </button>

      {isOpen && (
        <div
          className={`fixed inset-0 bg-black/30 backdrop-blur-sm z-40 transition-opacity duration-300 ${
            animate ? "opacity-100" : "opacity-0"
          }`}
          onClick={closeMenu}
        >
          <div
            className={`fixed top-0 right-0 w-64 h-full bg-[#0F2C5E] p-6 z-50 transition-transform duration-300 ${
              animate ? "translate-x-0" : "translate-x-full"
            }`}
            onClick={(e) => e.stopPropagation()}
          >
            <button onClick={closeMenu} className="self-end mb-6">
              <X size={24} className="text-white" />
            </button>

            <nav className="flex flex-col space-y-5 text-base font-medium tracking-wide">
              <Link to="/pricing" onClick={closeMenu}>Pricing</Link>
              <Link to="/due-dates" onClick={closeMenu}>2290 Due Dates</Link>
              <Link to="/contact" onClick={closeMenu}>Contact Us</Link>
            </nav>

            <div className="mt-10 flex flex-col space-y-4">
              {isAuthenticated ? (
               <>
                  <Link to="/dashboard" onClick={() => { closeMenu(); }}>
                    <button className="w-full px-5 py-2 bg-[#0F2C5E] text-white border border-white hover:bg-white hover:text-[#0F2C5E] transition-colors duration-150 text-sm uppercase tracking-wide">
                      File Form
                    </button>
                  </Link>
                  <button
                    onClick={() => { handleLogout(); closeMenu(); }}
                    className="w-full px-5 py-2 bg-transparent text-white border border-white hover:bg-white hover:text-[#0F2C5E] transition-colors duration-150 text-sm uppercase tracking-wide"
                  >
                    Logout
                  </button>
                </>
              ) : (
                <>
                  <Link to="/sign-up">
                    <button className="w-full px-5 py-2 bg-transparent text-white border border-white hover:bg-white hover:text-[#0F2C5E] transition text-sm uppercase tracking-wide">
                      Register
                    </button>
                  </Link>
                  <Link to="/sign-in">
                    <button className="w-full px-5 py-2 bg-white text-[#0F2C5E] border border-white hover:bg-gray-100 transition text-sm uppercase tracking-wide">
                      Login
                    </button>
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}

export default Header;
